/**
 * 특수 효과. 흔들림 / 서서히 나타남 / 아래서 올라옴 / 타자 / 빛나는 효과
 */
export enum TalkEffectType {
  Shake = 'shake',
  FadeIn = 'fade_in',
  Rise = 'fade_up',
  Typing = 'typing',
  Flick = 'flash',
  None = 'none',
}
